var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"flag",class:{ 'flag--lg': _vm.props.isLarge },style:(("background: url(/static/img/" + (encodeURI(_vm.props.flag)) + ")"))})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a82514","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/components/FlagIcon.vue
// module id = 1961
// module chunks = 0